import { Sparkles } from 'lucide-react';

const SophieIcon = ({ color = '#0D7E94', size = 16, ...props }) => (
  <Sparkles color={color} size={size} {...props} />
);

export default SophieIcon;
